module.exports = __webpack_public_path__ + "static/media/calendar-date.a92dab8b.svg";